import { useSyncReshippingRate } from "@babackapp/return-widget-components/hooks/use-reshipping-rate";
import { usePublicOrder } from "@babackapp/return-widget-components/queries/use-public-order";
import { Outlet, useParams } from "react-router-dom";
import { useWidgetLanguage } from "../hooks/use-widget-language";
import { useWidgetParams } from "../hooks/use-widget-params";

// Loads the order before any child route renders. usePublicOrder suspends until
// the order is in cache — and the underlying load-with-items fetch stores the
// order-scoped session JWT as a side effect. Without this gate, a deep link
// straight to /order/:orderId/return-requests races the order self-fetch against
// the return-request search that needs that token, so the search can fire with an
// empty Authorization header. The identification page used to provide this
// sequencing implicitly by loading the order before navigating.
export function ReturnWidgetOrderLayout() {
  const { orderId } = useParams<{ orderId: string }>();
  const { shopId } = useWidgetParams();
  const { data: order } = usePublicOrder(orderId!);
  // `lang` is resolved back-side from the Shopify customer locale, with the same
  // chain the return emails use, so the portal and the emails agree.
  const languageSettled = useWidgetLanguage(order?.lang);
  // The draft keeps a reshipping rate only while the shop bills it, so going
  // back to change a resolution or a reason cannot leave a rate behind that the
  // PaymentIntent and the return request would still charge.
  useSyncReshippingRate(orderId!, shopId);
  return languageSettled ? <Outlet /> : null;
}
